import script from "./projectDevice.vue?vue&type=script&setup=true&lang=js"
export * from "./projectDevice.vue?vue&type=script&setup=true&lang=js"

import "./projectDevice.vue?vue&type=style&index=0&id=06f6361c&lang=less"

const __exports__ = script;

export default __exports__